import { ThemeOptions } from '@mui/material';

export const lightThemeOptions: ThemeOptions = {
  palette: {
    mode: 'light',
    primary: {
      main: '#1E6EE5',
      light: '#61A0FF',
      dark: '#0B5BD2',
    },
    secondary: {
      main: '#384352',
      light: '#8895AC',
      dark: '#272F3A',
    },
    success: {
      main: '#10B40D',
      light: '#10B40D',
      dark: '#0E980B',
    },
    info: {
      main: '#0BACD0',
      light: '#0BACD0',
      dark: '#087C96',
    },
    warning: {
      main: '#FF7A0D',
      light: '#FF7A0D',
      dark: '#DB6300',
    },
    error: {
      main: '#F33321',
      light: '#F33321',
      dark: '#C61B0B',
    },
    aurora: {
      main: '#8811E3',
      light: '#8811E3',
      dark: '#720EBE',
      contrastText: '#FFFFFF',
    },
    text: {
      primary: 'rgba(13, 17, 23, 1)',
      secondary: 'rgba(82, 97, 117, 1)',
      disabled: 'rgba(141, 153, 176, 1)',
    },
    action: {
      active: '#4B596C',
      hover: 'rgba(136, 159, 196, 0.08)',
      selected: 'rgba(136, 159, 196, 0.14)',
      disabled: 'rgba(166, 177, 193, 0.8)',
      disabledBackground: 'rgba(202, 209, 218, 0.5)',
      focus: 'rgba(166, 177, 193, 0.5)',
    },
    other: {
      tooltip: '#d0d5dd',
      defaultPrimary: '#1E6EE5',
      outlinedBorder: 'rgba(26, 31, 39, 0.24)',
      backdropOverlay: 'rgba(26, 31, 39, 0.70)',
      filledInputBackground: 'rgba(26, 31, 39, 0.08)',
      standardInputLine: 'rgba(26, 31, 39, 0.42)',
    },
    elevation: {
      0: {
        background: 'none',
        shadow: '0px 0px 0px 1px rgba(26, 31, 39, 0.08) inset',
      },
      2: {
        background: 'rgba(249, 250, 251, 1)',
        shadow: '0px 0px 0px 1px rgba(26, 31, 39, 0.08) inset',
      },
      4: {
        background: 'rgba(243, 245, 246, 1)',
        shadow:
          '0px 1px 4px 1px rgba(13, 17, 23, 0.06), 0px 2px 8px 0px rgba(13, 17, 23, 0.06)',
      },
      6: {
        background: 'rgba(238, 239, 242, 1)',
        shadow:
          '0px 2px 4px 1px rgba(13, 17, 23, 0.1), 0px 2px 8px 0px rgba(13, 17, 23, 0.06)',
      },
      8: {
        background: 'rgba(231, 234, 238, 1)',
        shadow:
          '0px 3px 4px 1px rgba(13, 17, 23, 0.12), 0px 4px 8px 0px rgba(13, 17, 23, 0.08)',
      },
      12: {
        background: 'rgba(219, 223, 230, 1)',
        shadow:
          '0px 2px 8px 1px rgba(13, 17, 23, 0.14), 0px 4px 8px 0px rgba(13, 17, 23, 0.08)',
      },
      24: {
        background: 'rgba(207, 213, 221, 1)',
        shadow:
          '0px 4px 6px 1px rgba(13, 17, 23, 0.18), 0px 4px 10px 0px rgba(13, 17, 23, 0.06)',
      },
    },
    divider: 'rgba(26, 31, 39, 0.12)',
    background: {
      default: '#F3F4F7',
      paper: '#FFFFFF',
    },
    // @ts-expect-error There must be a way to fix this
    DataGrid: {
      // paper
      bg: '#ffffff',
    },
  },
};
